import React from 'react';
import './loader.css';
import spinner from '../../../assets/Loader/CM_loader.gif';
import spinnerBlack from '../../../assets/Gear-blk.gif';
import spinnerHsb from '../../../assets/Quotes/Horizon/gearHsb.gif';
import { isHorizon } from '../../../utils/brandHelper';

const Loader = (props) => {
  return (
    <div className="loaderWrapper">
      <div className="loader">
        <img src={isHorizon ? spinnerHsb : (props.color === "black" ? spinnerBlack : spinner)} alt="loading" />
        <p className="mt-4">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;
